module.exports = __webpack_public_path__ + "img/predict-sites.06befa35.png";